import { QueryResult } from '@apollo/client';
import { ClientQuery, ClientQueryVariables, useClientQuery } from 'generated/graphql';
import { useForm, UseFormReturn } from 'react-hook-form';
import { useParams } from 'react-router-dom';

type FormData = {
  firstName: string;
  lastName: string;
  email: string;
};

const getFormData = ({ client }: ClientQuery): FormData => ({
  firstName: client.firstName,
  lastName: client.lastName,
  email: client.email,
});

export const useEditClientForm = (): [
  QueryResult<ClientQuery, ClientQueryVariables>,
  UseFormReturn<FormData, any>
] => {
  const { clientId: id } = useParams() as { clientId: string };
  const form = useForm<FormData>();

  const client = useClientQuery({
    variables: { id },
    onCompleted: data => form.reset(getFormData(data)),
  });

  return [client, form];
};
